module.exports = __webpack_public_path__ + "static/media/mindfulness-for-sleep.6f1cd493.png";